/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CampusFromJSON(json) {
    return CampusFromJSONTyped(json, false);
}
export function CampusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'campusId': !exists(json, 'campusId') ? undefined : json['campusId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'campusCode': !exists(json, 'campusCode') ? undefined : json['campusCode'],
        'campusName': !exists(json, 'campusName') ? undefined : json['campusName'],
    };
}
export function CampusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'campusId': value.campusId,
        'propertyId': value.propertyId,
        'campusCode': value.campusCode,
        'campusName': value.campusName,
    };
}
